import useModals from 'src/Hooks/useModals'
import { useCompleteInstallation, useInstallationsContext } from 'src/Libs/installations/hooks'
import { clearInstallation, resetActiveValues } from 'src/State/Storage/StorageActions'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { refreshApiView } from '@e3dc-react/shell/State/ApiView/ApiViewActions'

export const useInstallationCompletionDialog = (installationId: number): { openCompleteInstallationConfirmationDialog: () => void } => {
  const { enqueueErrorStack, enqueueSuccessStack } = useSnackbar()
  const { openConfirmationModal } = useModals()
  const { refreshInstallations } = useInstallationsContext()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useCustomTranslation()

  const completeInstallation = useCompleteInstallation({
    onError: () => enqueueErrorStack(t('installation-configuration.component-list.complete-installation.error')),
    onSuccess: async () => {
      await refreshInstallations()
      dispatch(resetActiveValues())
      dispatch(clearInstallation())
      dispatch(refreshApiView())
      navigate('/')
      enqueueSuccessStack(t('installation-configuration.component-list.complete-installation.success'))
    },
  })

  const onConfirmInstallationCompleting = async (): Promise<void> => {
    await completeInstallation.mutateAsync({
      installationId: installationId,
    })
  }

  const openCompleteInstallationConfirmationDialog = (): void => {
    openConfirmationModal({
      onConfirm: onConfirmInstallationCompleting,
      text: t('installation-configuration.component-list.complete-installation.description'),
      title: t('installation-configuration.component-list.complete-installation.title'),
      buttonText: [t('common.cancel'), t('common.complete')],
    })
  }

  return {
    openCompleteInstallationConfirmationDialog,
  }
}
